import React, { useState } from 'react';
import StepShell from './StepShell';
import FieldStack from './FieldStack';
import { SelectField } from '../../../ui/select-field';
import { VIDEO_HOURS_OPTIONS } from '../../fixtures';
import { Monitor, Laptop, Tv } from 'lucide-react';

const Counter = ({ icon: Icon, label, value, onChange, max = 5 }) => (
  <div className='flex items-center gap-3 rounded-xl border border-border p-3'>
    <div className='w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-accent flex-shrink-0'>
      <Icon size={18} strokeWidth={1.5} />
    </div>
    <div className='flex-1 text-sm font-medium'>{label}</div>
    <div className='flex items-center gap-1.5'>
      <button
        type='button'
        onClick={() => onChange(Math.max(0, value - 1))}
        className='w-8 h-8 rounded-md border border-input bg-transparent hover:bg-muted text-sm'>
        −
      </button>
      <div className='w-8 text-center font-display text-lg tabular-nums'>{value}</div>
      <button
        type='button'
        onClick={() => onChange(Math.min(max, value + 1))}
        className='w-8 h-8 rounded-md border border-input bg-transparent hover:bg-muted text-sm'>
        +
      </button>
    </div>
  </div>
);

const WfhEquipment = () => {
  const [desktops, setDesktops] = useState(0);
  const [laptops, setLaptops] = useState(1);
  const [monitors, setMonitors] = useState(1);
  const [videoHours, setVideoHours] = useState('6-10');

  return (
    <StepShell
      title='Your home office'
      description='What kit do you use while working from home? Count yours only, not housemates.'>
      <FieldStack label='Equipment' hint='0 if you don’t use that type'>
        <div className='space-y-2'>
          <Counter icon={Monitor} label='Desktop computers' value={desktops} onChange={setDesktops} />
          <Counter icon={Laptop} label='Laptops' value={laptops} onChange={setLaptops} />
          <Counter icon={Tv} label='External monitors' value={monitors} onChange={setMonitors} max={10} />
        </div>
      </FieldStack>

      <FieldStack
        label='In a typical week, how many hours on video calls?'
        hint='Weekly total across Teams, Zoom, Meet, etc.'
        required>
        <SelectField
          options={VIDEO_HOURS_OPTIONS}
          value={videoHours}
          onChange={setVideoHours}
          placeholder='Pick a range...'
          className='mb-0'
        />
      </FieldStack>
    </StepShell>
  );
};

export default WfhEquipment;
